<template>
   <g>
      <path
         fill-rule="evenodd"
         clip-rule="evenodd"
         d="M6.49998 0C10.0893 0 13 2.91068 13 6.49998C13 10.0893 10.0893 13 6.49998 13C2.91068 13 0 10.0893 0 6.49998C0 2.91068 2.91068 0 6.49998 0ZM7.99045 4.09043L6.49998 5.58093L5.00955 4.09049L4.09046 5.00958L5.5809 6.49998L4.09046 7.99045L5.00955 8.90954L6.49998 7.4191L7.99045 8.90954L8.90954 7.99045L7.4191 6.49998L8.90954 5.00955L7.99045 4.09043Z"
         fill="#DC3545"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-flag-fix',
         viewBox: '0 0 13 13',
         width: 13,
         height: 13,
      };
   },
};
</script>
